import { Grid, Button, Typography, FormLabel, IconButton } from "@mui/material";
import BasicTextField from "../components/forms/formElements/BasicTextField";
import { useEffect, useState } from "react";
import SplitLayout from "../components/forms/formLayouts/SplitLayout";
import { useTheme } from "@mui/material/styles";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { Link, useNavigate } from "react-router-dom";
import useButtonStyles from "../styles/useButtonStyles";
import axios from "axios";
import { APIConstants } from "../constants/ApiConstants";
import UploadImage from "../components/ui/UploadImage";
import BasicModal from "../components/ui/BasicModal";
import BasicAutoComplete from "../components/ui/BasicAutoComplete";
import Loader from "../components/ui/Loader";
import SearchMemberDropdown from "../components/ui/SearchMemberDropdown";
import useFormStyles from "../styles/useFormStyles";
import { useAppSelector } from "../redux/hooks";
import CloseIcon from "@mui/icons-material/Close";
import { constant } from "../constants";
import useActiveMerchants from "../Hooks/merchant/useActiveMerchants";
export interface AddReceiptFormType {
  merchant: string;
  member: string;
  merchantType: string;
  scannedReceiptNo: string;
  receiptAmount: string;
  receiptImage: string;
  note: string;
}
export interface PropsType {
  closeDrawer?: Function;
  refreshApi?: () => void;
  memberEmailDefault?: boolean;
}
const AddReceipt = (props: PropsType) => {
  const { closeDrawer, refreshApi, memberEmailDefault } = props;
  const theme = useTheme();

  const initialFormValues: AddReceiptFormType = {
    merchant: "",
    member: "",
    merchantType: "",
    scannedReceiptNo: "",
    receiptAmount: "",
    receiptImage: "",
    note: "",
  };
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [clearForm, setClearForm] = useState(false);
  const [receiptFormState, setReceiptFormState] =
    useState<AddReceiptFormType>(initialFormValues);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [uploadError, setUploadError] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [memberSearched, setMemberSearched] = useState<boolean>(false);
  const [memberLoading, setMemberLoading] = useState<boolean>(false);
  const [axiosErrorMessage, setAxiosErrorMessage] = useState<string>(
    "Something went wrong"
  );
  const [maxReceiptAmount, setMaxReceiptAmount] = useState<number | null>(null);
  const navigate = useNavigate();
  const [searchMemberState, setSearchMemberState] = useState<any>({
    searchMemberState: "",
  });
  const formStyles = useFormStyles();
  const memberDetails = useAppSelector(
    (state: any) => state.persistReducers.getMemberList?.membersList
  );
  const filterMerchantList = useActiveMerchants();
  const listOfMerchants = filterMerchantList?.map((entity: any) => {
    return {
      id: entity.id,
      label: entity.name,
      // type: entity.type,
      type: entity.custom_fields.field.filter((field: any) => {
        return field?.name === "category";
      })[0]?.value,
    };
  });

  const disableSubmitButton = () => {
    if (
      receiptFormState.member === "" ||
      receiptFormState.merchant === "" ||
      receiptFormState.scannedReceiptNo === "" ||
      receiptFormState.receiptImage === "" ||
      (maxReceiptAmount !== null &&
        parseFloat(receiptFormState.receiptAmount) > maxReceiptAmount)
    )
      return true;
    else return false;
  };

  const addReceipt = async () => {
    setLoading(true);
    let memberEmail: any;

    try {
      memberEmail = await getCustomerEmail(receiptFormState.member);
    } catch (error) {
      console.error("getCustomerError", error);
    }

    try {
      const data = {
        merchant: listOfMerchants.filter(
          (merchant: any) => merchant.label === receiptFormState.merchant
        )[0]?.id,
        merchantType: receiptFormState.merchantType,
        memberId: memberEmail,
        receiptNumber: receiptFormState.scannedReceiptNo,
        amount: receiptFormState.receiptAmount,
        receiptImage: receiptFormState.receiptImage,
        remarks: receiptFormState.note,
        module: "receipts",
        feature: "receipts",
      };
      const response = await axios.post(
        process.env.REACT_APP_API_URL + APIConstants.receiptApi,
        data
      );
      setAxiosErrorMessage("Something went wrong");
      setUploadError(false);
      if (closeDrawer) {
        setTimeout(() => {
          if (refreshApi) refreshApi();
          closeDrawer(false);
        }, 4000);
      }
    } catch (error: any) {
      console.error("error", error);
      setAxiosErrorMessage(
        error?.response?.data?.error ?? "Something went wrong"
      );
      setUploadError(true);
    } finally {
      setLoading(false);
      setShowModal(true);
      setTimeout(() => {
        setClearForm(false);
      }, 2000);
    }
  };

  useEffect(() => {
    if (memberEmailDefault) {
      setReceiptFormState((prev: any) => {
        return { ...prev, member: memberDetails.id };
      });
    } else {
      setReceiptFormState((prev: any) => {
        return { ...prev, member: searchMemberState?.searchMemberState };
      });
    }
  }, [searchMemberState]);
  useEffect(() => {
    getMaxAmount();
  }, []);

  const submitHandler = async (e: React.SyntheticEvent) => {
    e.preventDefault();
    if (!receiptFormState.member) {
      setAxiosErrorMessage("Please select a member from the dropdown");
      setUploadError(true);
      setShowModal(true);
    } else {
      if (receiptFormState.receiptImage === "") {
        setDisableSubmit(true);
        return;
      } else {
        setDisableSubmit(false);
      }
      setMemberSearched(false);
      // setMemberError(true);
      await addReceipt();
      setReceiptFormState(initialFormValues);
    }
  };

  const getCustomerEmail = async (memberId: any) => {
    try {
      const response: any = await axios.get(
        process.env.REACT_APP_API_URL +
          APIConstants.getCustomer +
          `?id=${memberId}`
      );
      const memberEmail = response?.data?.data?.data?.email;
      return memberEmail;
    } catch (error) {
      console.error("error", error);
    }
  };

  const getMaxAmount = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_API_URL +
          APIConstants.getFraudDetection +
          `?module=receipts&feature=fraud_detect_configuration`
      );
      const data = response.data.result.max_receipt_amount;
      setMaxReceiptAmount(data);
    } catch (error) {
      console.error(error);
    }
  };
  const buttonStyles = useButtonStyles();
  const onCloseModal = () => {
    if (closeDrawer) closeDrawer(false);
  };
  return (
    <Grid
      display={"flex"}
      flexDirection={"column"}
      alignItems={"center"}
      width={"100%"}
      height={"100%"}
    >
      <Grid
        item
        width={"100%"}
        height={"15%"}
        display={"flex"}
        alignItems={"center"}
        borderBottom={`${theme?.border?.xsmall}${theme.color?.dividerLight}`}
        sx={{ background: theme.color?.background }}
      >
        <Grid
          item
          display={"flex"}
          alignItems={"center"}
          px={4}
          gap={2}
          justifyContent={"space-between"}
          width={"100%"}
        >
          <Typography
            sx={{
              fontFamily: theme.font?.fontFamily.primary,
              fontSize: theme.font?.fontSize.large,
              fontWeight: theme.font?.fontWeight.thick,
            }}
            pl={2}
          >
            Add Receipt
          </Typography>
          <IconButton
            aria-label="delete"
            onClick={closeDrawer ? () => closeDrawer(false) : () => {}}
          >
            <CloseIcon />
          </IconButton>
        </Grid>
      </Grid>

      <Grid height={"85%"} overflow={"auto"}>
        <Grid
          component={"form"}
          onSubmit={submitHandler}
          container
          item
          px={4}
          height={"100%"}
        >
          <Grid
            width={"100%"}
            py={3}
            borderBottom={theme.border?.newGreyBorder}
          >
            <Grid item width={"100%"}>
              <SplitLayout columns={[6, 6]}>
                <BasicAutoComplete
                  label={"Merchant *"}
                  setState={setReceiptFormState}
                  stateKey="merchant"
                  secondaryStateKey="merchantType"
                  options={listOfMerchants}
                  clear={clearForm}
                  required={true}
                />
                {memberEmailDefault ? (
                  <Grid>
                    <BasicTextField
                      label="Member email *"
                      readonly={true}
                      setState={setReceiptFormState}
                      placeholder=""
                      stateKey="member"
                      variant="outlined"
                      align="left"
                      defaultValue={memberDetails.email}
                      clear={clearForm}
                    />
                  </Grid>
                ) : (
                  <Grid item width={"100%"}>
                    <Grid>
                      <FormLabel
                        sx={{
                          ...formStyles.formLabel,
                          textAlign: "left",
                        }}
                      >
                        {"Member *"}
                      </FormLabel>
                      <SearchMemberDropdown
                        required={true}
                        setState={setSearchMemberState}
                        stateKey="searchMemberState"
                        secondaryStateKey="searchMemberState"
                        options={[]}
                      />
                    </Grid>
                  </Grid>
                )}
              </SplitLayout>
            </Grid>
            <Grid item width={"100%"}>
              <SplitLayout columns={[6, 6]}>
                <BasicTextField
                  label="Merchant Type *"
                  readonly={true}
                  setState={setReceiptFormState}
                  placeholder=""
                  stateKey="merchantType"
                  variant="outlined"
                  align="left"
                  required={true}
                  disableSubmit={setDisableSubmit}
                  defaultValue={receiptFormState.merchantType}
                  clear={clearForm}
                />
              </SplitLayout>
            </Grid>
          </Grid>
          <Grid
            width={"100%"}
            borderBottom={theme.border?.newGreyBorder}
            py={3}
          >
            <Grid item width={"100%"}>
              <SplitLayout columns={[6, 6]}>
                <BasicTextField
                  label="Scanned Receipt Number *"
                  setState={setReceiptFormState}
                  placeholder=""
                  stateKey="scannedReceiptNo"
                  variant="outlined"
                  align="left"
                  required={true}
                  disableSubmit={setDisableSubmit}
                  defaultValue={receiptFormState.scannedReceiptNo}
                  clear={clearForm}
                />

                <Grid>
                  <BasicTextField
                    label="Receipt Amount *"
                    setState={setReceiptFormState}
                    placeholder="$"
                    stateKey="receiptAmount"
                    variant="outlined"
                    align="left"
                    type="number"
                    required={true}
                    clear={clearForm}
                  />
                </Grid>
              </SplitLayout>
              {maxReceiptAmount !== null &&
                parseFloat(receiptFormState.receiptAmount) >
                  maxReceiptAmount && (
                  <Grid width={"97%"} display={"flex"} justifyContent={"end"}>
                    <Typography
                      sx={{
                        color: theme.palette.error.main,
                        fontSize: theme.font?.fontSize.tableBody,
                      }}
                    >
                      *Amount greater than the Max Receipt Amount
                    </Typography>
                  </Grid>
                )}
              <SplitLayout columns={[6, 6]}>
                <Grid>
                  <Typography sx={{ ...formStyles.formLabel }}>
                    Receipt Image*
                  </Typography>
                  <UploadImage
                    setState={setReceiptFormState}
                    stateKey="receiptImage"
                    disableSubmit={setDisableSubmit}
                    label=""
                    clear={clearForm}
                  />
                </Grid>
              </SplitLayout>
            </Grid>
          </Grid>

          <Grid
            item
            width={"100%"}
            sx={{ borderBottom: theme.border?.newGreyBorder }}
            py={3}
          >
            <SplitLayout columns={[12]}>
              <BasicTextField
                setState={setReceiptFormState}
                placeholder=""
                stateKey="note"
                variant="outlined"
                label="Remarks"
                align="left"
                multiline
                rows={3}
                clear={clearForm}
              />
            </SplitLayout>
          </Grid>
          <Grid
            height={"15%"}
            width={"100%"}
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
            gap={2}
          >
            <Button
              sx={{ ...buttonStyles.outlinedSecondary, width: "50%" }}
              onClick={closeDrawer ? () => closeDrawer(false) : () => {}}
            >
              Cancel
            </Button>
            <Button
              disabled={disableSubmit || disableSubmitButton()}
              type="submit"
              sx={{ ...buttonStyles.containedSecondary, width: "50%" }}
            >
              save
            </Button>
          </Grid>
        </Grid>
      </Grid>
      {showModal &&
        (uploadError ? (
          <BasicModal
            title={axiosErrorMessage}
            success={false}
            setState={setShowModal}
            onCloseModule={onCloseModal}
          />
        ) : (
          <BasicModal
            title={"Receipt Added Successfully!"}
            success={true}
            setState={setShowModal}
          />
        ))}
      {loading && <BasicModal content={<Loader />} />}
    </Grid>
  );
};

export default AddReceipt;
